<template>
  <div class="app-wrapper">
    <my-header></my-header>
    <div class="main-container">
      <search-box :showType="show_type"></search-box>
      <app-main></app-main>
      <div
        class="pk-container"
        v-if="
          contrastGoods &&
          ($route.name == 'smartwin' ||
            $route.name == 'proprietaryGoods' ||
            $route.name == 'scenehome' ||
            $route.name == 'goodsList' ||
            $route.name == 'goodsDetail')
        "
      >
        <div class="pk-header">
          [{{ contrastGoods.length }}/4]对比框
          <i class="el-icon-close" @click="delPk"></i>
        </div>
        <div class="pk-main">
          <div
            class="pk-item"
            v-for="(item, index) in contrastGoods"
            :key="index"
          >
            <img :src="$imgpath + item.goodsImage" />
            <p>{{ item.goodsName }}</p>
          </div>
          <div class="pk-btn" @click="jumpPk">对比</div>
          <div class="clear-pk" @click="delPk">
            <i class="el-icon-delete"></i> 清空对比栏
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from "./components/myHeader";
import appMain from "./components/appMain";
import searchBox from "./components/searchBox";

import { Message, MessageBox } from "element-ui";

export default {
  name: "layout",
  inject: ["reload"],
  components: {
    myHeader,
    appMain,
    searchBox,
  },
  data() {
    return {
      show_type: 1,
      nonetype_list: [
        "applyorder",
        "applyorderdetail",
        "approvaledit",
        "orderlist",
        "orderdetail",
        "orderlist/changegoods",
        "orderlist/returngoods",
        "settingindex",
        "address",
        "mycollect",
        "train",
        "orderreturn",
        "orderreturndetail",
        "secondApply",
        "secondApply2",
        "approval",
        "approvaldetail",
        "dataquery",
        "dataquery/applyorderquery",
        "orderquiry",
        "procurementCenter",
        "evaluate",
        "purchaseList",
        "recommend",
        "aboutus",
        "help/platformlogin",
        "help/searchbrowsing",
        "help/goodsorder",
        "help/orderapproval",
        "help/seeorder",
        "help/logisticsquery",
        "help/orderfailed",
        "help/confirmreceipt",
        "help/goodsseek",
        "help/logcheck",
        "help/step",
        "help/invoice",
        "help/reportform",
        "help/errfeedback",
        "help/problem",
      ],
      contrastGoods: [],
    };
  },

  created() {
    let that = this;
    if (that.nonetype_list.indexOf(that.$route.path.substr(1)) == -1) {
      that.show_type = 0;
    } else {
      that.show_type = 1;
    }
    this.contrastGoods = JSON.parse(localStorage.getItem("contrastgoods"));
  },
  computed: {
    listenPk() {
      return this.$store.state.pk_status;
    },
  },
  mounted() {},
  watch: {
    $route(to, from) {
      let that = this;
      if (that.nonetype_list.indexOf(that.$route.path.substr(1)) == -1) {
        that.show_type = 0;
      } else {
        that.show_type = 1;
      }
      that.contrastGoods = JSON.parse(localStorage.getItem("contrastgoods"));
    },
    listenPk(old, newd) {
      this.contrastGoods = JSON.parse(localStorage.getItem("contrastgoods"));
    },
  },
  methods: {
    delPk() {
      let that = this;
      MessageBox.confirm("确认清空比价栏？", "提示", {
        confirmButtonText: "清空",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("contrastgoods");
          that.$toast("清空成功");
          this.contrastGoods = [];
          this.$store.commit("changePkstatus");
        })
        .catch(() => {
          console.log("取消清空");
        });
    },
    jumpPk() {
      this.$router.push({
        name: "goodspk",
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.pk-container {
  width: 266px;
  position: fixed;
  right: 48px;
  top: 6vh;
  overflow: hidden;
  z-index: 998;

  .pk-header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #e63535;
    color: #ffffff;
    text-indent: 18px;

    .el-icon-close {
      margin-left: 112px;
      line-height: 40px;
      cursor: pointer;
    }
  }

  .pk-main {
    width: 100%;
    background: #ffffff;
    border-left: 1px solid #ededed;
    border-right: 1px solid #ededed;
    box-sizing: border-box;

    .pk-item {
      width: 90%;
      margin: 0 auto 10px;
      border-bottom: 1px solid #ededed;
      overflow: hidden;

      img {
        width: 71px;
        height: 71px;
        margin: 10px;
        float: left;
      }

      p {
        float: left;
        width: 128px;
        height: 48px;
        line-height: 24px;
        margin: 22px 0 0 2px;
        color: #333333;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }

  .pk-btn {
    width: 90%;
    height: 40px;
    line-height: 40px;
    background: #e63535;
    border-radius: 3px;
    color: #ffffff;
    margin: 0 auto 10px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }

  .clear-pk {
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #999999;
    font-size: 16px;
    background: #fafafa;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue